import { useEffect } from "react";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { MapContainer, TileLayer, Marker, Popup, GeoJSON, useMap } from "react-leaflet";

const COLORS = { riconsegna: "#B8860B", ritiro: "#0D3B52", extra: "#5C6B73", done: "#15803D", depot: "#D4AF37" };

const pin = (label, color) => L.divIcon({
  className: "",
  html: `<div style="background:${color};color:#fff;width:30px;height:30px;border-radius:9999px;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:13px;border:2px solid #fff;box-shadow:0 2px 8px rgba(0,0,0,.35)">${label}</div>`,
  iconSize: [30, 30],
  iconAnchor: [15, 15],
});

const Fit = ({ points }) => {
  const map = useMap();
  const key = JSON.stringify(points);
  useEffect(() => {
    if (points.length) map.fitBounds(points, { padding: [36, 36] });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map, key]);
  return null;
};

export const RouteMap = ({ route }) => {
  const pts = [[route.depot.lat, route.depot.lon], ...route.stops.map((s) => [s.lat, s.lon])];
  return (
    <div className="relative z-0 h-[360px] sm:h-[460px] rounded-2xl overflow-hidden border border-[#E2DDD5]" data-testid="route-map">
      <MapContainer center={pts[0]} zoom={10} scrollWheelZoom={false} className="h-full w-full">
        <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {route.geometry && <GeoJSON key={route.created_at} data={route.geometry} style={{ color: "#0D3B52", weight: 5, opacity: 0.8 }} />}
        <Marker position={pts[0]} icon={pin("A", COLORS.depot)}><Popup>Partenza: {route.depot.address}</Popup></Marker>
        {route.stops.map((s) => (
          <Marker key={s.seq} position={[s.lat, s.lon]} icon={pin(s.seq, s.arrived_at ? COLORS.done : COLORS[s.kind] || COLORS.extra)}>
            <Popup><strong>{s.seq}. {s.label}</strong><br />{s.address}<br />Arrivo stimato {s.eta}</Popup>
          </Marker>
        ))}
        <Fit points={pts} />
      </MapContainer>
    </div>
  );
};
